import api from '../../../api/axios';

// Get all clinics
export const getClinics = async () => {
  try {
    const response = await api.get('/api/admin/clinics');
    return response.data;
  } catch (error) {
    console.error('Error fetching clinics:', error);
    throw error;
  }
};

// Get single clinic by ID
export const getClinicById = async (id: number) => {
  try {
    const response = await api.get(`/api/admin/clinics/${id}`);
    return response.data;
  } catch (error) {
    console.error(`Error fetching clinic ${id}:`, error);
    throw error;
  }
};

// Create new clinic
export const createClinic = async (clinicData: any) => {
  try {
    const response = await api.post('/api/admin/clinics', clinicData);
    return response.data;
  } catch (error) {
    console.error('Error creating clinic:', error);
    throw error;
  }
};

// Update existing clinic
export const updateClinic = async (id: number, clinicData: any) => {
  try {
    const response = await api.put(`/api/admin/clinics/${id}`, clinicData);
    return response.data;
  } catch (error) {
    console.error(`Error updating clinic ${id}:`, error);
    throw error;
  }
};

// Delete clinic
export const deleteClinic = async (id: number) => {
  try {
    const response = await api.delete(`/api/admin/clinics/${id}`);
    return response.data;
  } catch (error) {
    console.error(`Error deleting clinic ${id}:`, error);
    throw error;
  }
};

// Get appointment types for selection
export const getAppointmentTypes = async () => {
  try {
    const response = await api.get('/api/appointment-types');
    return response.data;
  } catch (error) {
    console.error('Error fetching appointment types:', error);
    throw error;
  }
};